import BreadcrumbItem from "./BreadcrumbItem.vue";
import { pluginify } from "./../../util";
export default pluginify(BreadcrumbItem);
export { BreadcrumbItem };
